module.exports = __webpack_public_path__ + "static/img/Trent_Cotchin_desktop.214d396.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Trent_Cotchin_desktop.jpg
// module id = eSaU
// module chunks = 0